import { styled } from '@linaria/react';

import { hoverable } from '~theme/snippets';

export const GridCarouselItem = styled.div<{ isLast: boolean }>`
	min-height: 0;
	height: 100%;
	position: relative;
	scroll-snap-align: center;
	user-select: none;

	img {
		object-fit: cover;
		object-position: center;
		width: 100%;
		height: 100%;
		background: var(--color-black);
		// temp disable until design decision
		// opacity: ${({ isLast }) => (isLast ? '0.5' : 1)};
		// filter: ${({ isLast }) => (isLast ? 'blur(5px)' : 'none')};
	}
`;

export const GridCarouselPaginationItem = styled.li<{ active?: boolean }>`
	width: 10px;
	height: 10px;
	bottom: 8px;
	position: relative;
	${hoverable};
	&:before {
		content: '';
		display: block;
		position: absolute;
		width: 6px;
		height: 6px;
		left: 2px;
		top: 2px;
		border-radius: 100%;
		background-color: ${({ active }) =>
			active ? 'var(--bot-color-main)' : 'var(--color-white-05)'};
	}
`;

export const GridCarouselContainer = styled.div`
	width: 100%;
	height: 100%;
	.react-multi-carousel-list,
	.react-multi-carousel-track {
		height: inherit;
	}
`;
